export default "__VITE_ASSET__Db5YMYu6__"